export const setUser = user => ({
    type:'SET_USER',
    user
});
export const setToken = token => ({
    type:'SET_TOKEN',
    token
});
export const firstBoot = boot => ({
    type:'SET_FIRST_BOOT',
    boot
});
export const setRouterData = routerData => ({
    type:'SET_ROUTER_DATA',
    routerData
});
export const setLocation = location => ({
    type:'SET_LOCATION',
    location
});
export const setLanguage = language => ({
    type:'SET_LANGUAGE',
    language
});
